/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useContext} from 'react';
import { Disclosure } from '@headlessui/react'
import { useHistory } from 'react-router-dom';
import {
  MapIcon,
  DocumentReportIcon,
  FolderIcon,
  DatabaseIcon,
  CurrencyDollarIcon,
} from '@heroicons/react/outline';
import get from 'lodash/get';
import './Shell.css';
import Switch from './Switch';
import { FarmContext } from './FarmContext';
import { AppContext } from './AppContext';
import { useSoilToggle } from './Soils';
import { useNdviToggle } from './NDVI';
import { useFloodToggle } from './Flood';
import { useElevationToggle } from './Elevation';
import layers, { useLayerToggle } from './layers';
import { useAllCompsToggle } from './allCompsLayer';
import { useFKDToggle } from './FKD';
import { useScrapedCompsToggle } from './scrapedCompsLayer';
// import { useAttom } from './attom';
import { useCoreLogicOwnerTransfer } from './CoreLogicOwnerTransfer';
import { useBarcharts } from './barcharts';
import logo from './acretrader-logo.svg';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}


function MenuItem ({item}) {
    const { showing, toggleShowing } = useContext(AppContext);

   const setEnabled = item => val => {
    
    toggleShowing(item.id, val);
    if (item.onToggle) item.onToggle(val);
   }

   // TODO a should be <Link to="{item.href}" />
   if (!item.children) return <div key={item.id}>
    <div
      // href={item.href}
      onClick={item.onClick}
      className={classNames(
        (false)
          ? 'bg-gray-100 text-gray-900'
          : 'bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900',
        'group w-full flex items-center pl-2 py-2 text-sm font-medium rounded-md'
      )}
    >
      {item.icon && <item.icon
        className={classNames(
          (false) ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500',
          'mr-3 h-6 w-6'
        )}
        aria-hidden="true"
      />}
      <span className="truncate flex-1">{item.name || item.id}</span>
      {(!item.noSwitch) && <Switch enabled={get(showing, item.id)} setEnabled={setEnabled(item)} />}
    </div>
  </div>

  return <Disclosure as="div" key={item.id} className="space-y-1">
    {({ open }) => (
      <>
        <Disclosure.Button
          className={classNames(
            (false)
              ? 'bg-gray-100 text-gray-900'
              : 'bg-white text-gray-600 hover:bg-gray-50 hover:text-gray-900',
            'group w-full flex items-center pl-2 pr-1 py-2 text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500'
          )}
        >
          {item.icon && <item.icon className="text-gray-400 group-hover:text-gray-500 mr-3 h-6 w-6" aria-hidden="true" />}
          <span className="truncate">{item.name || item.id}</span>
          <svg
            className={classNames(
              open ? 'text-gray-400 rotate-90' : 'text-gray-300',
              'ml-auto h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150'
            )}
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
          </svg>
        </Disclosure.Button>
        <Disclosure.Panel className="space-y-1">
          {item.children.map((subItem) => (
            <div
              key={subItem.id}
              onClick={subItem.onClick}
              // href={subItem.href}
              className="group w-full flex items-center pl-11 pr-2 py-2 text-sm font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50"
            >
                <span className="truncate flex-1">{subItem.name || subItem.id}</span>
                {(!item.noSwitch) && <Switch enabled={get(showing, subItem.id)} setEnabled={setEnabled(subItem)}/>}
            </div>
          ))}
        </Disclosure.Panel>
      </>
    )}
  </Disclosure>
}


// TODO combine with shell
function NavBar({ navigation }) {
    const history = useHistory();
    const { user } = useContext(AppContext);
    return <Fragment>
      <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
        <div className="flex items-center flex-shrink-0 px-4">
          <img
            className="h-8 w-full"
            src={logo}
            alt="logo"
          />
        </div>
        <div className="w-full text-center text-lg text-gray-600"> Data Science </div>
        <nav className="mt-5 flex-1 px-2 bg-white space-y-1">
          <div className="w-full flex justify-center">
            <button
              type="button"
              className="order-1 ml-3 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:order-0 sm:ml-0"
              onClick={() => history.push("/fkd/new")}
            >
              + FKD
            </button>
            <button
              type="button"
              className="order-0 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 sm:order-1 sm:ml-3"
              onClick={() => history.push("/comp/new")}
            >
              + Comp
            </button>
          </div>
          {navigation.map((item) => <MenuItem key={item.id} item={item}/>)}
        </nav>
      </div>
      <div className="flex-shrink-0 flex border-t border-gray-200 p-4">
        <div className="flex-shrink-0 w-full group block">
          <div className="flex items-center">
            <div>
              <img
                className="inline-block h-9 w-9 rounded-full"
                src={user.photoURL}
                alt=""
              />
            </div>
            <div className="ml-3">
              <p className="text-sm font-medium text-gray-700 group-hover:text-gray-900">{user.displayName}</p>
              <p className="text-xs font-medium text-gray-500 group-hover:text-gray-700">{user.email.split('@')[0]}</p>
            </div>
          </div>
        </div>
      </div>
  </Fragment>
}

export default function LeftBar(){
  const { boundaryToggle, model } = useContext(FarmContext);
  const soilToggle = useSoilToggle();
  const layerToggle = useLayerToggle();
  const elevationToggle = useElevationToggle();
  const ndviToggle = useNdviToggle();
  const floodToggle = useFloodToggle();
  const allCompsToggle = useAllCompsToggle();
  const scrapedCompsToggle = useScrapedCompsToggle();
  // const { recorderToggle, taxAssessorToggle } = useAttom();
  const { coreLogicToggle } = useCoreLogicOwnerTransfer();
  const { grainBidsToggle } = useBarcharts();
  const { allKnowledgeToggle } = useFKDToggle();

  let modelT;
  if (model === 'comp') modelT = 'Comp';
  if (model === 'knowledge') modelT = 'FKD';

  const navigation = [
     // {name: "Satellite", icon: PhotographIcon, onToggle: layerToggle(mapboxSatellite)},
     {name: `${modelT} Boundary`, id: 'Boundary', icon: DatabaseIcon, onToggle: boundaryToggle},
     {name: `${modelT} Properties`, id: 'Properties', icon: DatabaseIcon},
     {id: "All Comps", icon: DatabaseIcon, onToggle: allCompsToggle},
     {id: "FKD", icon: DatabaseIcon, onToggle: allKnowledgeToggle},
     // {id: "+ New Comp", onClick: () => history.push("/comp/new"), noSwitch: true, icon: DatabaseIcon},
     // {id: "+ New FKD", onClick: () => history.push("/fkd/new"), noSwitch: true, icon: DatabaseIcon},
     {id: "County Stats", icon: DocumentReportIcon},
     {id: "Crop History", icon: DocumentReportIcon},
     {id: "Soils", icon: MapIcon, onToggle: soilToggle},
     {id: "Elevation", icon: MapIcon, onToggle: elevationToggle},
     {id: "NDVI", icon: MapIcon, onToggle: ndviToggle},
     {id: "WIP Flood", icon: MapIcon, onToggle: floodToggle},
     {id: "Scraped Comps", icon: DatabaseIcon, onToggle: scrapedCompsToggle},
     {id: "Courthouse Comps", icon: CurrencyDollarIcon, onToggle: coreLogicToggle},
     // {id: "ATTOM Recorder", icon: CurrencyDollarIcon, onToggle: recorderToggle},
     // {id: "ATTOM Tax Assessor", icon: CurrencyDollarIcon, onToggle: taxAssessorToggle},
     {id: "Barcharts Grain Bids", icon: CurrencyDollarIcon, onToggle: grainBidsToggle},
     {id: "More Layers", icon: FolderIcon, children: layers.map(l => ({
        id: l[0].id,
        onToggle: layerToggle(l)
      }))
     },
  ];


  return <NavBar navigation={navigation} />
}
